import { withInstall } from '@jdesign-vue/utils'
import Result from './src/result.vue'

import resultDialog from './src/result-dialog.vue'

export const JdResult = withInstall(Result)
export const JdResultDialog = withInstall(resultDialog)

export default JdResult

export * from './src/result'
export * from './src/result-dialog'
